import { useState } from "react";
import { NavLink } from "react-router-dom";
import { ChevronUp, ChevronDown } from "lucide-react";
import { IonCol, IonText } from "@ionic/react";

export const ProjectsDropdown = (props) => {
  const { projectOptions, handleClose = () => {} } = props;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  return (
    <IonCol
      className="dropdown-container"
      onMouseEnter={() => setIsDropdownOpen(true)}
      onMouseLeave={() => setIsDropdownOpen(false)}
    >
      <div className="dropdown-header" onClick={toggleDropdown}>
        <IonText className="dropdown-title nav-item-menu btn-shine">
          PROJECTS
        </IonText>
        &nbsp;
        {isDropdownOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>
      {isDropdownOpen && (
        <div className="dropdown-menu transparent-frame">
          {projectOptions.map((project, index) => (
            <NavLink
              key={index}
              to={project.path}
              className="dropdown-item"
              onClick={() => {
                setIsDropdownOpen(false);
                handleClose();
              }}
              style={({ isActive }) => ({
                color: isActive ? "#3ad246" : null,
              })}
            >
              {project.title}
              <div className="dropdown-subtitle">{project.musicStyle}</div>
            </NavLink>
          ))}
        </div>
      )}
    </IonCol>
  );
};
